import { light } from '@mui/material/styles/createPalette';

const configUrlOrgao = {
  ORGAO_CREATE_SITE: '/site/admin/cadastro/orgao/create',
  ORGAO_EDIT_SITE: '/site/admin/cadastro/orgao/edit/:id',
  ORGAO_LIST_SITE: '/site/admin/cadastro/orgao/list',
  ORGAO_EDIT_LK_SITE: '/site/admin/cadastro/orgao/edit/',
  ORGAO_LOGO_SITE: '/site/admin/cadastro/orgao/logo',

  ORGAO_FILTER_BY_SEARCH_EP: '/api/saber/admin/orgao', // não muda com layout
  ORGAO_API_EP: '/api/saber/admin/orgao', // não muda com layout
  ORGAO_API_EP_AXIOS: '/api/saber/admin/orgao/create/axios', // não muda com layout

  ORGAO_CREATE_SABER: '/saber/cadastro/orgao/create',
  ORGAO_EDIT_SABER: '/saber/cadastro/orgao/edit/:id',
  ORGAO_LIST_SABER: '/saber/cadastro/orgao/list',
  ORGAO_EDIT_LK_SABER: '/saber/cadastro/orgao/edit/',
  ORGAO_LOGO_SABER: '/saber/cadastro/orgao/logo'
};

export default configUrlOrgao;
